import type { IconColor } from '@freelancer/ui/icon';
import type { ButtonSize } from '../button';

export type DropdownFilterIconColor =
  | IconColor.FOREGROUND
  | IconColor.LIGHT
  | IconColor.SECONDARY;

export type DropdownFilterSize = ButtonSize.SMALL | ButtonSize.MID;

export enum DropdownFilterContentSize {
  FLUID = 'fluid', // Follow content's width
  INHERIT = 'inherit', // Follow trigger's width
}
